import type { SimulatorSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { ClearButton } from 'components/Editor/styled/Button'
import type { ElementStyleCss } from 'services/Branding/types'

const NavigationButtonStyled = styled(ClearButton)<{
  $styles: ElementStyleCss<SimulatorSchemaType>
  $position: 'left' | 'right'
}>`
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${({ $styles }) => $styles.navigation?.backgroundColor};
  color: ${({ $styles }) => $styles.icon?.color};
  background-size: cover;
  background-repeat: no-repeat;
  background-image: ${({ $styles, $position }) =>
    $position === 'left'
      ? $styles.backButton?.backgroundImage
      : $styles.nextButton?.backgroundImage};
  box-shadow: ${({ $styles }) => $styles.button_effects?.boxShadow};

  &:hover {
    cursor: pointer;
    ${({ $styles }) => `background-color:${$styles.hoverButton?.backgroundColor}`};
  }
`

export default NavigationButtonStyled
